// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as CodeRouteImport } from './routes/code'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TeamRouteImport } from './routes/team'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as HelpSlugRouteImport } from './routes/help/$slug'
import { Route as NewsIndexRouteImport } from './routes/news/index'
import { Route as NewsSlugRouteImport } from './routes/news/$slug'
import { Route as NewsUnsubscribeRouteImport } from './routes/news/unsubscribe'
import { Route as StatusIndexRouteImport } from './routes/status/index'
import { Route as StatusUnsubscribeRouteImport } from './routes/status/unsubscribe'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const ChangelogRoute = ChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const CodeRoute = CodeRouteImport.update({
            id: '/code',path: '/code',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const TeamRoute = TeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const HelpIndexRoute = HelpIndexRouteImport.update({
            id: '/help/',path: '/help/',getParentRoute: () => rootRouteImport
          })
const HelpSlugRoute = HelpSlugRouteImport.update({
            id: '/help/$slug',path: '/help/$slug',getParentRoute: () => rootRouteImport
          })
const NewsIndexRoute = NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => rootRouteImport
          })
const NewsSlugRoute = NewsSlugRouteImport.update({
            id: '/news/$slug',path: '/news/$slug',getParentRoute: () => rootRouteImport
          })
const NewsUnsubscribeRoute = NewsUnsubscribeRouteImport.update({
            id: '/news/unsubscribe',path: '/news/unsubscribe',getParentRoute: () => rootRouteImport
          })
const StatusIndexRoute = StatusIndexRouteImport.update({
            id: '/status/',path: '/status/',getParentRoute: () => rootRouteImport
          })
const StatusUnsubscribeRoute = StatusUnsubscribeRouteImport.update({
            id: '/status/unsubscribe',path: '/status/unsubscribe',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,ChangelogRoute: ChangelogRoute,CodeRoute: CodeRoute,FaqRoute: FaqRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,TeamRoute: TeamRoute,TermsRoute: TermsRoute,HelpSlugRoute: HelpSlugRoute,NewsSlugRoute: NewsSlugRoute,NewsUnsubscribeRoute: NewsUnsubscribeRoute,StatusUnsubscribeRoute: StatusUnsubscribeRoute,HelpIndexRoute: HelpIndexRoute,NewsIndexRoute: NewsIndexRoute,StatusIndexRoute: StatusIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)